import { sdkRequest } from '@eventbrite/legacy-infra.http';

const unremind = (eventId: string) => {
  return sdkRequest(`/destination/events/${eventId}/unremind/`, { method: 'POST' });
};

type TrackablePromise<T> = Promise<T> & {
  completed: boolean;
};

function trackPromise<T>(p: Promise<T>): TrackablePromise<T> {
  const promise = p as TrackablePromise<T>;
  promise.completed = false;
  promise.finally(() => {
    promise.completed = true;
  });
  return promise;
}

let singletonRequest: TrackablePromise<{
  action_performed: boolean;
}> | null = null;

const remind = (eventId: string) => {
  if (singletonRequest && !singletonRequest.completed) return singletonRequest;
  singletonRequest = trackPromise(sdkRequest(`/destination/events/${eventId}/remind/`, { method: 'POST' }));
  return singletonRequest;
};

type GetReminderStatusResponse = {
  reminder_events: unknown[];
};

const getReminderStatus = async (userId: string, eventId: string): Promise<boolean> => {
  const response = (await sdkRequest(`/destination/users/${userId}/reminders/?event_id=${eventId}`, {
    method: 'GET',
  })) as GetReminderStatusResponse;
  const reminderEvents = response?.reminder_events;
  return reminderEvents != null && Array.isArray(reminderEvents) && reminderEvents.length > 0;
};

type OrganizationMarketingOptIn = {
  organizationId: string;
  firstName: string;
  lastName: string;
  email: string;
};

const addOrganizationMarketingOptIn = ({ organizationId, firstName, lastName, email }: OrganizationMarketingOptIn) =>
  sdkRequest(
    `/api/v3/missive/organization/${organizationId}/contacts/`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        contact_list_item: {
          first_name: firstName,
          last_name: lastName,
          contact: email,
        },
        contact_list_type: 'organization_marketing_opt_in',
      }),
    },
    process.env.NEXT_PUBLIC_PROXY_API_V3 ? '/e' : '',
  );

export { unremind, remind, getReminderStatus, addOrganizationMarketingOptIn };
